import {
    Paper,
    Stack,
    Typography,
    useMediaQuery,
    useTheme,
} from '@mui/material'
import { ProcessStatusGroup, RosterType } from '__generated__/graphql'
import React from 'react'
import { useNavigate } from 'react-router-dom'
import RosterTypePill from 'shared/components/RosterTypePill'
import { getPxAsRem } from 'shared/utils'
import DetailsRow, { DetailsRowProps } from './DetailsRow'
import ProcessStatusPieGraph from './processStatusPieGraph'

export interface RosterListProps {
    rosterName?: string
    rosterId: string
    details: DetailsRowProps
    navigationTarget?: string
    statusGroupsForGraph: ProcessStatusGroup[]
    isSelectable?: boolean
    rosterType: RosterType
    showRosterType?: boolean
}
const ClientRosterCardPreview: React.FunctionComponent<RosterListProps> = ({
    rosterName,
    rosterId,
    details,
    navigationTarget,
    statusGroupsForGraph,
    isSelectable = true,
    showRosterType = true,
    rosterType,
}) => {
    const navigate = useNavigate()
    const theme = useTheme()
    const isMdScreen = useMediaQuery(theme.breakpoints.down('md')) // Detect if the screen is md or smaller

    const mainContent = () => {
        return (
            <Stack
                padding={getPxAsRem(24, 24)}
                direction={'column'}
                spacing={2}
                display={'flex'}
                alignItems={'flex-start'}
                justifyContent={'space-evenly'}
                flexGrow={1}
            >
                {showRosterType && <RosterTypePill rosterType={rosterType} />}
                <Typography variant="h3" alignItems={'center'}>
                    {rosterName}
                </Typography>

                <DetailsRow {...details} />
                {isMdScreen && (
                    <ProcessStatusPieGraph
                        rosterId={rosterId}
                        groups={statusGroupsForGraph}
                    />
                )}
            </Stack>
        )
    }

    return (
        <Stack
            component={Paper}
            borderRadius={getPxAsRem(3, 8)}
            direction="row"
            width="100%"
            display={'flex'}
            minWidth={getPxAsRem(350)}
            spacing={3}
            justifyContent={'space-between'}
            sx={{ cursor: isSelectable ? 'pointer' : '' }}
            onClick={() => {
                if (isSelectable && navigationTarget) {
                    navigate(`${navigationTarget}/${rosterId}`)
                }
            }}
        >
            {mainContent()}
            {!isMdScreen && (
                <ProcessStatusPieGraph
                    rosterId={rosterId}
                    groups={statusGroupsForGraph}
                />
            )}
        </Stack>
    )
}

export default ClientRosterCardPreview
